import { render, staticRenderFns } from "./VGlobalStats.vue?vue&type=template&id=81f58088&"
import script from "./VGlobalStats.vue?vue&type=script&lang=js&"
export * from "./VGlobalStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports